import React, { FC, PropsWithChildren, useContext, useEffect } from 'react';

import Sider from 'components/layouts/Sider';
import CookiesLayout from 'components/common/Cookies';
import UserSubscription from 'components/user/UserSubscription';
import { ViboThemeContext } from 'components/context/ViboThemeContext';

import { shouldRepaintColor } from './constants';
import { useRootPath } from 'graphql/hooks/navigation';
import { usePrevious } from 'services/common/dataProcessingHelpers';

import useStyles from './style';

const Dashboard: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  const { resetToAppColor } = useContext(ViboThemeContext);

  const rootPath = useRootPath();
  const prevFirstPath = usePrevious(rootPath);

  useEffect(() => {
    if (!shouldRepaintColor(rootPath) && shouldRepaintColor(prevFirstPath)) {
      resetToAppColor();
    }
  }, [rootPath]);

  return (
    <>
      <div className={classes.layout}>
        <Sider />
        <div className="content">{children}</div>
      </div>
      <CookiesLayout />
      <UserSubscription />
    </>
  );
};

export default Dashboard;
